import {gql} from "@apollo/client";

export const GET_RANDOM_CREDIT_KARMA = gql`
    query {
        person {
            firstName
            lastName
            email
            phone
            phone2
            creditProfile
            isVeteran
            workingWithRealtor
        }
        property {
            value
            type
            used
            location {
                state
                city
                zip
            }
            loan {
                purpose
                amount
                cashOut
                product
                program
            }
        }
    }
`;